<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <!-- Spinner de carga -->
        <div id="status" *ngIf="!loaded && !error">
          <div class="spinner">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        <!-- Error de carga -->
        <ngb-alert [dismissible]="false" type="danger" *ngIf="error">
          {{ error }}
        </ngb-alert>

        <!-- Anomalías -->
        <div *ngIf="caso?.anomalias" class="mb-4"> <!-- Añadido margen inferior -->
          <div *ngFor="let anomalia of caso.anomalias_descripcion" class="alert alert-danger" role="alert">
            <i class="mdi mdi-alert-circle"></i> {{ anomalia }}
          </div>
        </div>

        <!-- Nueva sección de Datos del Caso con más espacio -->
        <div class="row" *ngIf="loaded"> <!-- Margen superior más amplio -->
          <div class="col-12">
            <h5 class="section-title" i18n>Datos del Caso</h5>
          </div>

          <!-- Mostrar el estado -->
          <div class="col-md-6">
            <strong i18n>Estado: </strong> {{ caso?.estado || '-' }}
          </div>

          <!-- Mostrar la fecha de solicitud formateada -->
          <div class="col-md-6">
            <strong i18n>Fecha de Solicitud: </strong> {{ caso?.fecha_solicitud | date:'dd/MM/yyyy' || '-' }}
          </div>

          <!-- Mostrar la cuantía de la demanda -->
          <div class="col-md-6 mt-2">
            <strong i18n>Cuantía de la Demanda: </strong> {{ caso?.cuantia_demanda | currency:'EUR':'symbol':'1.2-2' ||
            '-' }}
          </div>

          <!-- Mostrar la cuantía de la reconvención -->
          <div class="col-md-6 mt-2">
            <strong i18n>Cuantía de la Reconvención: </strong> {{ caso?.cuantia_reconvencion |
            currency:'EUR':'symbol':'1.2-2' || '-' }}
          </div>
        </div>

        <!-- Aquí empieza la nueva sección de las 4 columnas con más espacio -->
        <div class="row mt-2" *ngIf="loaded && !error"> <!-- Más margen superior -->
          <div class="col-12">
            <h5 class="section-title" i18n>Participantes</h5>
          </div>

          <!-- Demandantes -->
          <div class="col-md-3">
            <h5 class="column-title">
              <ng-container *ngIf="hasReconvencion(); else demandantesDefault">
                <span i18n>DEMANDANTES<br>RECONVENIDOS</span>
              </ng-container>
              <ng-template #demandantesDefault>
                <span i18n>DEMANDANTES</span>
              </ng-template>
            </h5>

            <!-- Spinner mientras se cargan los demandantes -->
            <div *ngIf="isLoadingDemandantes" class="spinner-container-mini mb-3">
              <div class="spinner">
                <div></div>
                <div></div>
              </div>
            </div>

            <div *ngIf="demandantesLoaded && demandantesList.length > 0; else noDemandantes">
              <div *ngFor="let demandante of demandantesList" class="mb-3">
                <!-- Nombre de la parte con nacionalidad fuera de la card -->
                <h6 class="mb-1" style="font-size: 1em; font-weight: bold;">
                  {{ demandante.razon_social }} 
                  <span *ngIf="demandante.nacionalidad">({{ demandante.nacionalidad }})</span>
                </h6>
                

                <!-- Mostrar mensaje "Sin participantes" si la lista está vacía -->
                <div *ngIf="!demandante.participantes || demandante.participantes.length === 0"
                  class="card institucion-card mb-2">
                  <div class="card-body">
                    <p class="text-muted mb-0" i18n>En rebeldía</p>
                  </div>
                </div>

                <!-- Lista de cards de participantes de cada demandante -->
                <div *ngFor="let participante of demandante.participantes" class="card institucion-card mb-2">
                  <div class="card-body d-flex flex-row align-items-start">
                    <img *ngIf="avatarUrls[participante.id_usuario]" [src]="avatarUrls[participante.id_usuario]"
                      class="rounded-circle" style="width: 40px; height: 40px; object-fit: cover;">
                    <div class="ms-3">
                      <h6 class="mb-0">{{ participante.nombre }} {{ participante.apellidos }}</h6>
                      <p class="mb-0">{{ traducirTipos(participante.tipo) }}</p>
                      <p class="mb-0">{{ participante.despacho }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ng-template #noDemandantes>
              <p *ngIf="demandantesLoaded">
                <ng-container *ngIf="hasReconvencion(); else noDemandantesDefault">
                  <span i18n>No se ha encontrado ningún Demandante reconvenido</span>
                </ng-container>
                <ng-template #noDemandantesDefault>
                  <span i18n>No se ha encontrado ningún Demandante</span>
                </ng-template>
              </p>
            </ng-template>
          </div>

          <!-- Demandados -->
          <div class="col-md-3">
            <h5 class="column-title">
              <ng-container *ngIf="hasReconvencion(); else demandadosDefault">
                <span i18n>DEMANDADOS RECONVINIENTES</span>
              </ng-container>
              <ng-template #demandadosDefault>
                <span i18n>DEMANDADOS</span>
              </ng-template>
            </h5>

            <!-- Spinner mientras se cargan los demandados -->
            <div *ngIf="isLoadingDemandados" class="spinner-container-mini mb-3">
              <div class="spinner">
                <div></div>
                <div></div>
              </div>
            </div>

            <div *ngIf="demandadosLoaded && demandadosList.length > 0; else noDemandados">
              <div *ngFor="let demandado of demandadosList" class="mb-3">
                <!-- Nombre de la parte con nacionalidad fuera de la card -->
                <h6 class="mb-1" style="font-size: 1em; font-weight: bold;">
                  {{ demandado.razon_social }} 
                  <span *ngIf="demandado.nacionalidad">({{ demandado.nacionalidad }})</span>
                </h6>

                <!-- Mostrar mensaje "Sin participantes" si la lista está vacía -->
                <div *ngIf="!demandado.participantes || demandado.participantes.length === 0"
                  class="card institucion-card mb-2">
                  <div class="card-body">
                    <p class="text-muted mb-0" i18n>En rebeldía</p>
                  </div>
                </div>

                <!-- Lista de cards de participantes de cada demandado -->
                <div *ngFor="let participante of demandado.participantes" class="card institucion-card mb-2">
                  <div class="card-body d-flex flex-row align-items-start">
                    <img *ngIf="avatarUrls[participante.id_usuario]" [src]="avatarUrls[participante.id_usuario]"
                      class="rounded-circle" style="width: 40px; height: 40px; object-fit: cover;">
                    <div class="ms-3">
                      <h6 class="mb-0">{{ participante.nombre }} {{ participante.apellidos }}</h6>
                      <p class="mb-0">{{ traducirTipos(participante.tipo) }}</p>
                      <p class="mb-0">{{ participante.despacho }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ng-template #noDemandados>
              <p *ngIf="demandadosLoaded">
                <ng-container *ngIf="hasReconvencion(); else noDemandadosDefault">
                  <span i18n>No se ha encontrado ningún Demandado reconviniente</span>
                </ng-container>
                <ng-template #noDemandadosDefault>
                  <span i18n>No se ha encontrado ningún Demandado</span>
                </ng-template>
              </p>
            </ng-template>
          </div>


          <!-- Columna de Tribunal -->
          <div class="col-md-3">
            <h5 class="column-title" i18n>TRIBUNAL</h5>

            <!-- Spinner mientras se cargan los tribunales -->
            <div *ngIf="isLoadingTribunales" class="spinner-container-mini mb-3">
              <div class="spinner">
                <div></div>
                <div></div>
              </div>
            </div>

            <div *ngIf="tribunalesLoaded && tribunalesList.length > 0; else noTribunales">
              <div *ngFor="let tribunal of tribunalesList" class="card mb-3 institucion-card position-relative"
                [ngClass]="{'opacity-50': tribunal.estado === 'SUSTITUIDO'}">

                <!-- Marca de agua "SUSTITUIDO" -->
                <div *ngIf="tribunal.estado === 'SUSTITUIDO'" class="watermark">SUSTITUIDO</div>

                <div class="card-body d-flex flex-row align-items-start">
                  <img *ngIf="avatarUrls[tribunal.id_usuario!]" [src]="avatarUrls[tribunal.id_usuario!]"
                    class="rounded-circle" style="width: 40px; height: 40px; object-fit: cover;">
                  <div class="ms-3">
                    <h6 class="mb-0">{{ tribunal.nombre }} {{ tribunal.apellidos }}</h6>
                    <p>{{ traducirTipos(tribunal.tipo) }}<br>
                      {{ tribunal.arbitro_rol }}<br>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <ng-template #noTribunales>
              <p *ngIf="tribunalesLoaded" i18n>No se ha encontrado ningún Tribunal</p>
            </ng-template>
          </div>


          <!-- Columna de Instituciones -->
          <div class="col-md-3">
            <h5 class="column-title" i18n>INSTITUCIÓN<br>Equipo CIIAM</h5>

            <!-- Spinner mientras se cargan las instituciones -->
            <div *ngIf="isLoadingInstituciones" class="spinner-container-mini mb-3">
              <div class="spinner">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>

            <div *ngIf="institucionesLoaded && institucionesList.length > 0; else noInstituciones">
              <div *ngFor="let institucion of institucionesList" class="card mb-3 institucion-card">
                <div class="card-body d-flex flex-row align-items-start">
                  <img *ngIf="avatarUrls[institucion.id_usuario!]" [src]="avatarUrls[institucion.id_usuario!]"
                    class="rounded-circle" style="width: 40px; height: 40px; object-fit: cover;">
                  <div class="ms-3">
                    <h6 class="mb-0">{{ institucion.nombre }} {{ institucion.apellidos }}</h6>
                    <p>{{ traducirTipos(institucion.tipo) }}</p>
                  </div>
                </div>
              </div>
            </div>
            <ng-template #noInstituciones>
              <p *ngIf="institucionesLoaded" i18n>No se ha encontrado ninguna Institución</p>
            </ng-template>
          </div>
        </div>
        <div class="row mt-2" *ngIf="loaded && !error && !disableOptions"> <!-- Más margen superior -->
          <div class="col-12">
            <h5 class="section-title" i18n>Histórico de cambios</h5>
          </div>
          <app-list-log [tipo]="'expediente'"></app-list-log>
        </div>
      </div>
    </div>
  </div>
</div>
